// header.js — Beauty Charms premium header behaviour
(function () {
  const header = document.querySelector('[data-bc-header]');
  if (!header) return;

  const isTransparentCapable = header.dataset.transparent === 'true';
  const hero = document.querySelector('[data-bc-hero]');

  // Keep the reserved top-space (and the hero's pull-up margin) in sync
  // with the header's REAL rendered height, so an announcement bar or
  // any text wrapping never causes an overlap.
  function syncHeaderHeightVar() {
    const height = header.offsetHeight;
    if (height > 0) {
      document.documentElement.style.setProperty('--site-header-height', height + 'px');
      document.documentElement.style.setProperty('--site-header-height-mobile', height + 'px');
    }
  }

  function updateHeaderState() {
    if (!isTransparentCapable || !hero) {
      header.classList.remove('is-over-hero');
      return;
    }
    const heroRect = hero.getBoundingClientRect();
    const headerHeight = header.offsetHeight;
    // Header stays transparent while its bottom edge is still within the hero
    if (heroRect.bottom > headerHeight) {
      header.classList.add('is-over-hero');
    } else {
      header.classList.remove('is-over-hero');
    }
  }

  // Throttle with requestAnimationFrame so the layout-reading work in
  // updateHeaderState() runs at most once per paint frame, instead of
  // synchronously on every single scroll event (which was forcing repeated
  // layout recalculation and causing the visible scroll glitch/flicker).
  let ticking = false;
  function onScrollOrResize() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      updateHeaderState();
      ticking = false;
    });
  }

  syncHeaderHeightVar();
  updateHeaderState();
  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', () => {
    syncHeaderHeightVar();
    onScrollOrResize();
  }, { passive: true });

  // Mobile drawer
  const drawerOpenBtn = document.querySelector('[data-bc-drawer-open]');
  const drawer = document.getElementById('bc-mobile-drawer');
  if (drawerOpenBtn && drawer) {
    drawerOpenBtn.addEventListener('click', () => {
      drawer.classList.add('is-open');
      drawerOpenBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });
    drawer.querySelectorAll('[data-bc-drawer-close]').forEach((el) => {
      el.addEventListener('click', () => {
        drawer.classList.remove('is-open');
        drawerOpenBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }
})();